/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Outlet } from 'react-router-dom';

import clsx from 'clsx';
import Header2 from '../header/Header2';
import Footer from '../footer/Footer';

function HomeLayout(props) {
  return (
    <div className=''>
      <Header2 {...props} />
      <main className='relative mx-auto my-0 max-w-screen-cwidth bg-nwhite-200 font-sans'>
        <section className={clsx('flex flex-row ')}>
          <div className={clsx('w-full bg-nwhite-200 px-2 break:px-10')}>
            <div className='mt-5 h-full break:mt-2'>
              <Outlet />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

HomeLayout.propTypes = {};

export default HomeLayout;
